var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorLens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.448,
    height: 13.448,
    viewBox: "0 0 13.448 13.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-color-lens",
    "data-name": "Icon material-color-lens",
    d: "M11.224,4.5a6.724,6.724,0,1,0,0,13.448,1.121,1.121,0,0,0,.829-1.875,1.116,1.116,0,0,1,.837-1.86h1.322a3.737,3.737,0,0,0,3.735-3.735C17.948,7.175,14.937,4.5,11.224,4.5ZM7.115,11.224A1.121,1.121,0,1,1,8.235,10.1,1.119,1.119,0,0,1,7.115,11.224ZM9.356,8.235a1.121,1.121,0,1,1,1.121-1.121A1.119,1.119,0,0,1,9.356,8.235Zm3.735,0a1.121,1.121,0,1,1,1.121-1.121A1.119,1.119,0,0,1,13.092,8.235Zm2.241,2.988A1.121,1.121,0,1,1,16.454,10.1,1.119,1.119,0,0,1,15.333,11.224Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#858c94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorLens);
export default __webpack_public_path__ + "static/media/color-lens.7310a365c5e29da2c3a68f5ebb7ff426.svg";
export { ForwardRef as ReactComponent };